export interface DeleteUserMemoRequest {
  id: string
  userMemoId: number
  revision: number
}

export function DeleteUserMemoRequestToJSON(value: DeleteUserMemoRequest): any {
  return {
    id: value.id !== '' ? value.id : undefined,
    user_memo_id: value.userMemoId !== 0 ? value.userMemoId : undefined,
    revision: value.revision !== 0 ? value.revision : undefined
  }
}
